import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-delete-deal-confirmation',
    templateUrl: './delete-deal-confirmation.component.html',
    styleUrls: ['./delete-deal-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteDealConfirmationComponent {
  deal: any;

  constructor(
    public dialogRef: MatDialogRef<DeleteDealConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      deal: any
    }
  ) {
    this.deal = data.deal;
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
